import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=70ee9343&scoped=true&"
import script from "./BaseModal.vue?vue&type=script&lang=js&"
export * from "./BaseModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=70ee9343&prod&lang=scss&"
import style1 from "./BaseModal.vue?vue&type=style&index=1&id=70ee9343&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee9343",
  null
  
)

export default component.exports